import React, { Component, Fragment } from 'react';
import { BryntumFullscreenButton } from './BryntumFullscreenButton';
import { BryntumButton } from './BryntumButton';
import { BryntumThemeCombo } from './BryntumThemeCombo';
export class BryntumDemoHeader extends Component {
    getLink() {
        const match = /(.*?\/)(examples.*?\/frameworks\/.*?)\/(build|out|dist)/.exec(document.location.href);
        return match ? `${match[1]}examples/#example-${match[2].replace(/\//gm, '-').replace('examples-frameworks', 'frameworks')}` : '#';
    }
    getTitle() {
        return this.props.title || document.title.split(' - ')[1] || document.title;
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        return (React.createElement(Fragment, null,
            React.createElement("header", { className: "demo-header" },
                React.createElement("div", { id: "title-container" },
                    React.createElement("a", { id: "title", href: this.getLink() },
                        React.createElement("h1", null, this.getTitle()))),
                this.props.children,
                this.props.themeCombo && React.createElement(BryntumThemeCombo, null),
                React.createElement(BryntumButton, { text: "Download Trial", href: "https://bryntum.com/download/?product=scheduler", cls: "b-green b-raised" }),
                React.createElement(BryntumFullscreenButton, null))));
    }
}
BryntumDemoHeader.defaultProps = {
    themeCombo: true
};
//# sourceMappingURL=BryntumDemoHeader.js.map